import React from "react";

export const Movie = ({ title, poster, rating, popularity, releaseDate }) => {
  const colorizeRating = (rating) => {
    if (parseInt(rating) < 1) return "hsl(211, 17%, 34%)";
    if (parseInt(rating) < 6) return "hsl(359, 94%, 62%)";
    if (parseInt(rating) < 8) return "hsl(42, 93%, 64%)";
    return "hsl(162, 43%, 46%)";
  };

  return (
    <div className="movie-card">
      <h3>{title}</h3>
      <img
        src={`https://image.tmdb.org/t/p/w500${poster}`}
        alt={`poster of ${title}`}
        style={{ width: "250px", borderRadius: "0.5rem", margin: "1rem 0" }}
      />
      <h5 style={{ color: colorizeRating(rating) }}>{rating}</h5>
      <h5>Popularity: {popularity}</h5>
      <h5>Release Date: {releaseDate}</h5>
    </div>
  );
};
